import { requestMetaActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export const requestMetaReducer = createReducer(
  {},
  {
    [requestMetaActions.update.type]: (state, { payload = {} }) => {
      // TODO: Remove when it is implemented by WebShell (DEX-2793)
      const result = { ...payload };
      if (payload.language.code === 'no') {
        result.language.code = 'nb';
      }
      return {
        ...result,
      };
    },
  },
);
